export default __webpack_public_path__ + "static/media/form-image-bg.45713f43.png";